export default __webpack_public_path__ + "static/media/pickuponly_deactive.7519c04f.svg";